export default __webpack_public_path__ + "static/media/bci-11.fb91559c.svg";